// Fahrzeug-Markenlogos für die Kfz-Objektmappe.
//
// Bewusst KEIN vollständiger Satz: der Hersteller-Katalog (risikoKfzStep/
// manufacturers.ts) kennt ~285 Marken, hier liegen nur die im Bestand
// gängigen. Alles Übrige fällt auf die Fahrzeug-Silhouette zurück — die
// Marke steht ohnehin als Text in der Zeile, das Logo ist Beiwerk.
//
// Die Dateien sind freigestellte PNGs (weißer Hintergrund entfernt), damit sie
// auf der hellen Kartenfläche wie auf farbigem Grund sitzen.

import audi from "../../assets/carLogos/audi.png";
import bmw from "../../assets/carLogos/bmw.png";
import citroen from "../../assets/carLogos/citroen.png";
import fiat from "../../assets/carLogos/fiat.png";
import ford from "../../assets/carLogos/ford.png";
import hyundai from "../../assets/carLogos/hyundai.png";
import kia from "../../assets/carLogos/kia.png";
import mazda from "../../assets/carLogos/mazda.png";
import mercedes from "../../assets/carLogos/mercedes.png";
import mini from "../../assets/carLogos/mini.png";
import opel from "../../assets/carLogos/opel.png";
import peugeot from "../../assets/carLogos/peugeot.png";
import porsche from "../../assets/carLogos/porsche.png";
import renault from "../../assets/carLogos/renault.png";
import seat from "../../assets/carLogos/seat.png";
import skoda from "../../assets/carLogos/skoda.png";
import tesla from "../../assets/carLogos/tesla.png";
import volvo from "../../assets/carLogos/volvo.png";
import vw from "../../assets/carLogos/vw.png";

/**
 * Suchbegriff → Logo. Die Schlüssel werden als Teilstring gegen den
 * normalisierten Herstellernamen geprüft, deshalb stehen längere Varianten
 * vor kürzeren („mercedes-benz" vor „mercedes" wäre redundant, aber
 * „volkswagen" muss vor „vw" stehen, sonst greift nie der lange Name).
 */
const LOGOS: { keys: string[]; src: string }[] = [
  { keys: ["mercedes", "daimler"], src: mercedes },
  { keys: ["volkswagen", "vw"], src: vw },
  { keys: ["audi"], src: audi },
  { keys: ["bmw"], src: bmw },
  { keys: ["mini"], src: mini },
  { keys: ["porsche"], src: porsche },
  { keys: ["opel"], src: opel },
  { keys: ["ford"], src: ford },
  { keys: ["skoda", "škoda"], src: skoda },
  { keys: ["seat", "cupra"], src: seat },
  { keys: ["renault"], src: renault },
  { keys: ["peugeot"], src: peugeot },
  { keys: ["citroen", "citroën"], src: citroen },
  { keys: ["fiat"], src: fiat },
  { keys: ["volvo"], src: volvo },
  { keys: ["tesla"], src: tesla },
  { keys: ["hyundai"], src: hyundai },
  { keys: ["kia"], src: kia },
  { keys: ["mazda"], src: mazda },
];

/** Logo zum Herstellernamen, oder null wenn die Marke nicht hinterlegt ist. */
export const carLogoFor = (manufacturer?: string | null): string | null => {
  const raw = (manufacturer ?? "").trim().toLowerCase();
  if (!raw) return null;
  // Exakter Wortlaut zuerst — sonst würde „Mini" in „Mini Cooper" korrekt,
  // aber auch in einem hypothetischen „Minicar" fälschlich greifen.
  const exact = LOGOS.find((l) => l.keys.some((k) => k === raw));
  if (exact) return exact.src;
  const partial = LOGOS.find((l) => l.keys.some((k) => raw.includes(k)));
  return partial?.src ?? null;
};
